import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Select from "react-select";

import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import { Edit_Commision, Get_Settings_byid } from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import LoadingSpinner from "views/Components/loadingSpinner";
import ProcessingLoader from "views/Components/processingLoader";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class editcommision extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "1",
      commision: "0",
      commisionError: null,
      processing: true,
      settingsloading: false,
      processingLoader: false,
      _notificationSystem: null,
      errormessages: [],
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.item_code_error = React.createRef();
  }

  componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700,
    );
    this.setState({ settingsloading: true }, () => {
      var id = JSON.parse(localStorage.getItem("commisionid"));

      Get_Settings_byid(id, obj).then((res) => {
        console.log(res);
        if (res.data.success == true) {
          var com = res.data.data;

          this.setState({ commision: com.setting_value });

          this.setState({ settingsloading: false });
        }
      });
    });
  }
  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {/* <b>Network Error</b>. */}
          <b>{getApiErrorMessage(error)}</b>
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Commision</b> - Updated Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  onSubmit = () => {
    this.setState({ errormessages: [] });
    let error = false;
    if (this.state.commision.length == 0) {
      error = true;
      this.setState({
        commisionError: (
          <small className="text-danger">Commision is required.</small>
        ),
      });
    } else {
      this.setState({ commisionError: null });
    }
    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      this.setState({ processingLoader: true }, () => {
        Edit_Commision(this.state.commision, obj)
          .then((res) => {
            if (res.data.success === false) {
              let message = res.data.data;
              this.handleClick("bl");
            } else if (res.data.success === true) {
              this.setState({ processingLoader: false });
              this.handleSuccess("bl");
            }
          })
          .catch((error) => {
            console.log(error, "== error");
            this.handleNetworkError("bl", error);
          });
      });
    }
  };

  render() {
    return (
      <div className="main-content">
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />
          {this.state.settingsloading ? <LoadingSpinner /> : ""}
          {this.state.processingLoader ? <ProcessingLoader /> : ""}
          <Row>
            <Col md={12}>
              <Card
                content={
                  <form>
                    <FormGroup>
                      <ControlLabel>Commision</ControlLabel>
                      <FormControl
                        disabled={
                          this.state.settingsloading == false ? "" : "disabled"
                        }
                        name="commision"
                        value={this.state.commision}
                        onWheel={(e) => e.target.blur()}
                        onChange={(event) => {
                          this.setState({ commision: event.target.value });
                          event.target.value === ""
                            ? this.setState({
                                commisionError: (
                                  <small className="text-danger">
                                    Commision is required.
                                  </small>
                                ),
                              })
                            : this.setState({ commisionError: null });
                        }}
                        placeholder="Enter Commision"
                        style={{ width: "200px" }}
                        min={0}
                        type="number"
                      />
                      {this.state.commisionError}
                    </FormGroup>

                    <Button
                      onClick={this.onSubmit.bind(this)}
                      disabled={this.state.processingLoader}
                      class="btn-color" //bsStyle="info"
                      fill
                    >
                      Update
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default editcommision;
